import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { TranslateModule } from '@ngx-translate/core';
import { AssetStorageUploadEditorFormType } from '../shared/asset-storage-edit-detail-form/asset-storage-upload-editor-form-type';
import { FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { MultiUploadUploaderComponent } from "../../../shared/multi-upload-uploader/multi-upload-uploader.component";
import { AssetStorageEditTabGroupComponent } from "../shared/asset-storage-edit-tab-group/asset-storage-edit-tab-group.component";

@Component({
    selector: 'app-asset-storage-multi-upload',
    templateUrl: './asset-storage-multi-upload.component.html',
    styleUrl: './asset-storage-multi-upload.component.scss',
    imports: [DialogModule, TranslateModule, CommonModule, MultiUploadUploaderComponent, AssetStorageEditTabGroupComponent]
})
export class AssetStorageMultiUploadComponent {

  @Output()
  public OnClose: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('multiAssetUploadDialog')
  public dialog: DialogComponent;

  @ViewChild('multiUploadUploaderComponent')
  public multiUploadUploaderComponent: MultiUploadUploaderComponent;

  @ViewChild("assetEditTabGroupComponent")
  public assetEditTabGroupComponent: AssetStorageEditTabGroupComponent;

  public assetStorageUploadEditorForms: FormGroup<AssetStorageUploadEditorFormType>[] = [];
  public selectedAssetStorageUploadEditorForm: FormGroup<AssetStorageUploadEditorFormType> = null;

  public uploadPath: string;

  public isUploading: boolean = false;

  public get canSave() {
    return this.assetStorageUploadEditorForms.length && (this.assetStorageUploadEditorForms?.every((form) => form.valid) ?? false) && !this.assetEditTabGroupComponent?.assetImageEditorComponent?.hasPendingChanges();
  }

  private isFullScreen: boolean = false;

  constructor(
    private toastService: ToastService
  ) { }

  public onCancel() {
    this.dialog.hide();
    this.resetDialog();
  }

  public onOpen(args: any): void {
    //Preventing the default dialog focus
    args.preventFocus = true;
  }

  public async onSave() {
    if (!this.canSave) {
      this.assetStorageUploadEditorForms.forEach((form) => {
        form.markAllAsTouched();
        form.markAsDirty();
      });
      if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
        this.toastService.showWarning('i18n.domain.assets.asset-storage.edit-asset-storage.form-invalid.title',
          'i18n.domain.assets.asset-storage.edit-asset-storage.form-invalid.message', null);
      }
      return;
    }
    this.isUploading = true;

    //Get editor data
    var extension = this.selectedAssetStorageUploadEditorForm.controls.fileExtension.value?.toLowerCase();
    if ((extension == "jpg" || extension == "jpeg" || extension == "png") &&
      this.assetEditTabGroupComponent?.assetImageEditorComponent?.imageEditorObj) {
      await this.assetEditTabGroupComponent.getImageDataFromCanvas();
    }

    //The uploader handles the upload itself
    this.multiUploadUploaderComponent.upload();
  }

  public onUploadSuccessful() {
    this.OnClose.emit();
    this.dialog.hide();
    this.resetDialog();
  }

  public assignAssets(uploadPath: string) {
    this.uploadPath = uploadPath;
    this.dialog.show(false);
  }

  public fileForEditSelected(fileId: string) {
    this.selectedAssetStorageUploadEditorForm = null;
    if (fileId != null) {
      //Exit possible fullscreen mode
      if (this.isFullScreen) {
        this.dialog.show(false);
      }
      setTimeout(() => {
        this.selectedAssetStorageUploadEditorForm = this.assetStorageUploadEditorForms.find((form) => form.controls.intermediateFileInfo.value.id === fileId) ?? null;
      }, 50);
    }
  }

  public setScreenSize(isFullScreen: boolean) {
    this.isFullScreen = isFullScreen;
    isFullScreen ? this.dialog.show(true) : this.dialog.show(false);
  }

  private resetDialog() {
    this.isFullScreen = false;
    this.selectedAssetStorageUploadEditorForm = null;
    this.isUploading = false;
    this.assetStorageUploadEditorForms = [];
    this.multiUploadUploaderComponent?.clearUploader();
    this.assetEditTabGroupComponent?.assetEditDetailComponent?.resetMultiselectFilter();
  }
}
